import React from 'react';
import Hero from '../components/Hero';
import HeroImg from '../assets/tcn3.png';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

function Convocatorias() {
  return (
    <div>
      <Navbar />
      <Hero
        clase='hero'
        img={HeroImg}
        title=''
        textstyle='Hero-text-mid'
        btnstyle='hide'
      />
      <Footer />
    </div>
  );
}

export default Convocatorias;
